export const AMAZON_CLOUD_FRONT_URL = 'https://cdn.dailymealz.app';

export const MEAL_STATUS = { ACTIVE: 'active', INACTIVE: 'inactive' };
